package com.nonopn.skywatcher.app.utils

actual val RootPath: String
    get() {
        return eu.codlab.files.RootPath
    }
